import { get, set } from 'idb-keyval';

/**
 * v5 — Option "Menu sans média en haut" (mode compact plein écran).
 *
 * Certains restaurants n'ont pas de visuel d'ambiance et préfèrent afficher
 * le menu en PLEIN ÉCRAN, sans le grand média (photo/vidéo) du haut.
 *
 * Quand hideProfileMedia === true :
 *  - le média du haut (ProfileMedia) est masqué
 *  - le header est réduit à une fine bande (les points cachés admin/plein écran
 *    restent accessibles)
 *  - la zone menu s'étend pour occuper quasiment tout l'écran
 *
 * ⚠️ DÉSACTIVÉ PAR DÉFAUT → aucun restaurant existant n'est impacté.
 */

const STORAGE_KEY = 'displayModeSettings';

export interface DisplayModeSettings {
  /** Masquer le média (photo/vidéo) du haut et passer en plein écran menu */
  hideProfileMedia: boolean;
}

export const DEFAULT_DISPLAY_MODE: DisplayModeSettings = {
  hideProfileMedia: false, // désactivé par défaut
};

/** Événement émis quand le réglage change (pour rafraîchir l'affichage sans reload) */
export const DISPLAY_MODE_EVENT = 'displayModeSettingsUpdated';

export async function getDisplayModeSettings(): Promise<DisplayModeSettings> {
  try {
    const stored = await get<DisplayModeSettings>(STORAGE_KEY);
    if (stored && typeof stored === 'object') {
      // spread : les valeurs sauvegardées écrasent les défauts (rétrocompat)
      return { ...DEFAULT_DISPLAY_MODE, ...stored };
    }
  } catch (e) {
    console.error('[DisplayMode] getDisplayModeSettings error', e);
  }
  return { ...DEFAULT_DISPLAY_MODE };
}

export async function saveDisplayModeSettings(
  settings: DisplayModeSettings
): Promise<void> {
  try {
    await set(STORAGE_KEY, settings);
    // Notifier l'app pour un rafraîchissement immédiat (pas de reload)
    window.dispatchEvent(
      new CustomEvent(DISPLAY_MODE_EVENT, { detail: settings })
    );
  } catch (e) {
    console.error('[DisplayMode] saveDisplayModeSettings error', e);
  }
}
